<template>
    <vue-final-modal
        v-slot="{ params }"
        name="DialogBase"
        classes="modal-container"
        content-class="p-4 rounded w-full max-w-[90%] xs:max-w-[23.375rem] bg-white relative xs:min-w-[23.375rem] max-h-[100%] overflow-auto"
        :lock-scroll="true"
        :click-to-close="false"
        :z-index-base="500"
    >
        <button
            v-if="params.closeicon"
            class="btn btn-circle btn-ghost border-0 absolute right-1 top-1"
            @click.stop="$emit('closed')"
        >
            <SvgIcon
                icon-name="close"
                class="text-gray-400 w-6 h-6 cursor-pointer"
            />
        </button>
        <div class="border-b text-base xs:text-lg text-gray-900 font-bold pb-3 border-gray-100 border-b border-gray-200">
            <slot name="title">
                {{ params.title }}
            </slot>
        </div>
        <div class="py-5 text-[0.93rem] xs:text-base text-gray-700 border-b border-gray-100">
            <slot name="content">
                <div v-html="params.content" />
            </slot>
        </div>
        <div class="action mt-0 pt-4 flex flex-wrap justify-end">
            <slot name="action">
                <button
                    v-if="params.cancelButton"
                    class="btn btn-accent rounded-full"
                    @click.stop="$emit('cancel')"
                >
                    {{ params.cancelButton }}
                </button>
                <button
                    v-if="params.confirmButton"
                    class="btn  rounded-full"
                    :class="[params.isErrorButton ?'btn-error':'gradient-primary' ]"
                    @click.stop="$emit('confirm')"
                >
                    {{ params.confirmButton }}
                </button>
            </slot>
        </div>
    </vue-final-modal>
</template>
<script>
export default {
    /**  關於 params = {
        id: 'IQ',
        title: '請確認',
        content: '因所選變更項目需要填寫投資屬性問卷，系統將自動加入在此次變更當中',
        confirmButton: '確認', // 不傳不顯示
        isErrorButton: true, // 確認是紅色按鈕嗎？紅色：藍色
        cancelButton: '取消',
        closeicon: false, // 顯示叉叉？
    }; */
    emits: ['closed', 'confirm', 'cancel'],
};
</script>

<style lang="scss" scoped>
:deep(.modal-container) {
    @apply flex justify-center items-center;
    .action {
        button {
            @apply mr-2 xs:mr-3;
            &:last-child {
                @apply mr-0;
            }
        }
    }
}
</style>
